import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class AuthUrlService {
	private readonly authParams = [
		"loginHint",
		"login_hint",
		"code",
		"state",
		"session_state",
		"error",
		"error_description",
		"error_uri",
		"correlation_id",
	];

	getLoginHint(): string | null {
		const params = new URLSearchParams(window.location.search);
		return params.get("loginHint") || params.get("login_hint");
	}

	clearAuthParams(): void {
		const url = new URL(window.location.href);
		const hashParams = url.hash.startsWith("#")
			? new URLSearchParams(url.hash.slice(1))
			: null;
		const hasQueryParams = this.authParams.some((key) =>
			url.searchParams.has(key)
		);
		const hasHashParams = Boolean(
			hashParams &&
				this.authParams.some((key) => hashParams.has(key))
		);

		if (!hasQueryParams && !hasHashParams) {
			return;
		}

		this.authParams.forEach((key) => {
			url.searchParams.delete(key);
			hashParams?.delete(key);
		});
		url.hash = hashParams?.toString() ? `#${hashParams.toString()}` : "";

		window.history.replaceState(
			window.history.state,
			document.title,
			`${url.pathname}${url.search}${url.hash}`
		);
	}

	currentRelative(): string {
		return `${window.location.pathname}${window.location.search}${window.location.hash}`;
	}

	toAbsolute(returnUrl: string): string {
		return new URL(returnUrl, window.location.origin).toString();
	}

	removeAuthParams(returnUrl: string): string {
		const url = new URL(returnUrl, window.location.origin);
		this.authParams.forEach((key) => url.searchParams.delete(key));
		return `${url.pathname}${url.search}${url.hash}`;
	}
}
